<script setup>

const props = defineProps(['field', 'modelValue'])
const emit = defineEmits(['update:modelValue'])
</script>

<template>
<v-textarea
	:label="field.label"
	:model-value="modelValue || ''"
	hide-details="auto"
	@update:model-value="(val) => emit('update:modelValue', val)"
/>
</template>

<style lang="scss" scoped>

</style>